import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_search",
  "use": "icon-icon_search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon_search\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M7.333 1.333c3.312 0 6 2.688 6 6s-2.688 6-6 6-6-2.688-6-6 2.688-6 6-6Zm0 10.667A4.666 4.666 0 0 0 12 7.333a4.665 4.665 0 0 0-4.667-4.666 4.665 4.665 0 0 0-4.666 4.666A4.665 4.665 0 0 0 7.333 12Zm5.657.047 1.886 1.886-.943.943-1.886-1.886.943-.943Z\" fill=\"#93949D\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol